<template>
<nav class="custom-nav">
    <Dropdown title="ΔΩΜΑΤΙΑ" titlen="ACCOMMODATION" :items="services" :itemsen="servicesen"/>
</nav>
</template>

<script>
import Dropdown from './Dropdown'

export default{
    name: 'white-navbar',
    components: {
        Dropdown
    },
     data () {
        return{
            services: [
                {
                    title: 'DOUBLE LOFT',
                    link: '/double-loft/'
                },
                {
                    title: 'TWIN STANDARD',
                    link: '/twin-standard/'
                },
                {
                    title: 'TRIPLE STANDARD',
                    link: '/triple-standard/'
                },
            ],
            servicesen: [
                {
                    title: 'DOUBLE LOFT',
                    link: '/double-loft/?lang=en'
                },
                {
                    title: 'TWIN STANDARD',
                    link: '/twin-standard/?lang=en'
                },
                {
                    title: 'TRIPLE STANDARD',
                    link: '/triple-standard/?lang=en'
                },
            ],
           
        }
    }

}
</script>
<style >
 nav{
        display: flex;
        align-items: center;
    }
.sidebar-drop{
    position: absolute !important;
    left: 0px;
}
    nav .menu-item{
        color:#fff;
        position: relative;
        text-align:center;
        border-bottom: 3px solid transparent;
        display: flex;
        transition: 0.4s;
    }

    nav .menu-item a{
        color:inherit;
        text-decoration:none;
    }
</style>